module.exports = __webpack_public_path__ + "static/img/FK.0940196c.svg";